import { render, staticRenderFns } from "./RecipeAdd1.vue?vue&type=template&id=b1d30a8e&scoped=true&"
import script from "./RecipeAdd1.vue?vue&type=script&lang=js&"
export * from "./RecipeAdd1.vue?vue&type=script&lang=js&"
import style0 from "./RecipeAdd1.vue?vue&type=style&index=0&id=b1d30a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d30a8e",
  null
  
)

export default component.exports